enum QuestionTypes {
  SingleChoice = 'singleChoice',
  MultiChoice = 'multiChoice',
  ShortText = 'shortText'
};

export default QuestionTypes;
